import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { add, g, remove } from '../other/function.js';
gsap.registerPlugin(ScrollTrigger);

const msg = g('.message');

if (msg) {
  const header = g('.header');
  const messageHeight = msg.getBoundingClientRect().height;
  const headerHeight = header.getBoundingClientRect().height;

  const body = g('main') || document.body;
  header.style.top = `${messageHeight}px`;
  body.style.paddingTop = `${headerHeight + messageHeight}px`;
  document.documentElement.style.setProperty('--msg-offset', `${messageHeight}px`);

  ScrollTrigger.refresh();

  ScrollTrigger.create({
    start: 'top top',
    end: `${window.innerHeight}px top`,
    onEnter: () => {
      gsap.to([header, msg], {
        y: 0,
      });
      gsap.to(body, {
        paddingTop: headerHeight + messageHeight,
      });
      document.documentElement.style.setProperty('--msg-offset', `${messageHeight}px`);
    },
    onEnterBack: () => {
      gsap.to([header, msg], {
        y: 0,
      });
      gsap.to(body, {
        paddingTop: headerHeight + messageHeight,
      });
      document.documentElement.style.setProperty('--msg-offset', `${messageHeight}px`);
    },
    onLeave: () => {
      gsap.to([header, msg], {
        y: -messageHeight,
      });
      gsap.to(body, {
        paddingTop: headerHeight,
      });
      document.documentElement.style.setProperty('--msg-offset', `${0}px`);
    },
  });
}

if (g('.one-article-section__top.fixed')) {
  ScrollTrigger.create({
    start: 'top top',
    end: `250px top`,
    onEnter: () => {
      remove(g('.one-article-section__top.fixed'));
    },
    onEnterBack: () => {
      remove(g('.one-article-section__top.fixed'));
    },
    onLeave: () => {
      add(g('.one-article-section__top.fixed'));
    },
  });
}

if (g('.catalog-section__buttons-mobile')) {
  ScrollTrigger.create({
    start: '20px top',
    end: `200px top`,
    onEnter: () => {
      remove(g('.catalog-section__buttons-mobile--hidden'));
    },
    onEnterBack: () => {
      remove(g('.catalog-section__buttons-mobile--hidden'));
    },
    onLeave: () => {
      add(g('.catalog-section__buttons-mobile--hidden'));
    },
  });
}

if (g('.fixed-wrapper')) {
  ScrollTrigger.create({
    start: '20px top',
    end: `800px top`,
    onEnter: () => {
      remove(g('.fixed-wrapper'));
    },
    onEnterBack: () => {
      remove(g('.fixed-wrapper'));
    },
    onLeave: () => {
      add(g('.fixed-wrapper'));
    },
  });
}

const btns = g('.one-article-section__top button');

if (btns) {
  btns?.forEach((btn) => {
    btn?.addEventListener('click', () => {
      const type = btn.getAttribute('class');
      const section = g(`[data-go="${type}"]`);
      if (!section) return;
      if (section.tagName === 'BUTTON') {
        const item = section;
        add(item);
        const content = item.querySelector(':scope > .content');
        content.style.height = content.getAttribute('data-height');
      }
      remove(btns);
      add(btns.filter((btn) => btn.getAttribute('class') === type));
      const header = document.querySelector('header');
      const headerHeight = header?.offsetHeight || 0;
      const top =
        section.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight -
        g('.one-article-section__top', document, true)[0]?.offsetHeight -
        (Number(
          document.documentElement.style.getPropertyValue('--msg-offset').replace('px', ''),
        ) || 0);
      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    });
  });

  g('.one-article-section__text .more').onclick = () => {
    const section = g(`[data-go="har"]`);
    if (!section) return;
    const item = section;
    add(item);
    const content = item.querySelector(':scope > .content');
    content.style.height = content.getAttribute('data-height');
    remove(btns);
    add(btns.filter((btn) => btn.getAttribute('class') === 'har'));
    const header = document.querySelector('header');
    const headerHeight = header?.offsetHeight || 0;
    const top =
      section.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight -
      g('.one-article-section__top', document, true)[0]?.offsetHeight -
      (Number(document.documentElement.style.getPropertyValue('--msg-offset').replace('px', '')) ||
        0);
    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  };
}
